<template>
    <!-- if value corrected, show corrected value alongside original value, with attribution -->
    <span v-if="correctedText">
        <!-- | marks are used to distringuish original and corrected values in json_pdf -->
        <span id="supplierCorrected" :style="{ display: 'none' }">{{ fieldSupplier }}||{{ correctedText }}|||</span>
        <strike>{{ fieldSupplier }}</strike> {{ correctedText }}
    </span>
    <!-- otherwise show original value with attribution  -->
    <span v-else>{{ fieldSupplier }}</span>
</template>

<script>
import { getLatestLogFieldValue } from '@/services/logService';
export default {
    props: {
        fieldArray: {
            type: Array,
            required: true
        },
        fieldSupplier: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            getLatestLogFieldValue
        };
    },
    computed: {
        correctedText() {
            return this.getLatestLogFieldValue(this.fieldArray, true) || '';
        }
    }
};
</script>
